const ConvertDate = ({ date }) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const formatYYYYMM = (date) => {
    const [, month] = date.split('-');
    return monthNames[parseInt(month, 10) - 1];
  };

  const formatYYYYMMDD = (date) => {
    const [year, month, day] = date.split('-');
    return `${monthNames[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
  };

  const formatISO = (date) => {
    // Parse ISO 8601 without converting timezones
    const [datePart, timePart] = date.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');
    const ampm = parseInt(hours, 10) >= 12 ? 'PM' : 'AM';
    const formattedHours = (parseInt(hours, 10) % 12) || 12; // Convert to 12-hour format
    return `${monthNames[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  const formatDateTime = (date) => {
    // Handle non-ISO datetime strings directly
    const [datePart, timePart] = date.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');
    const ampm = parseInt(hours, 10) >= 12 ? 'PM' : 'AM';
    const formattedHours = (parseInt(hours, 10) % 12) || 12; // Convert to 12-hour format
    return `${monthNames[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  if (/^\d{4}-\d{2}$/.test(date)) {
    return formatYYYYMM(date);
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return formatYYYYMMDD(date);
  } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(date)) {
    return formatISO(date);
  } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date)) {
    return formatDateTime(date);
  } else {
    return date;
  }
};

export default ConvertDate;

